var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173103",
    "data-name": "Group 173103",
    transform: "translate(21603 -9493)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144683",
    "data-name": "Rectangle 144683",
    width: 16,
    height: 30,
    transform: "translate(-21603 9493)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11553",
    "data-name": "Path 11553",
    d: "M4,19.333H14V18H4Z",
    transform: "translate(-21604 9490.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11554",
    "data-name": "Path 11554",
    d: "M8.583,9H4v1.333H14V9H8.583Z",
    transform: "translate(-21604 9497)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.826e7c740793e952f9557702724c33e9.svg";
export { ForwardRef as ReactComponent };